import { Dialog, Typography } from '@mui/material';
import { ButtonComponent } from './ButtonComponent';

interface IProps {
	open: boolean;
	title: string;
	subtitle?: string;
	buttonText?: string;
	buttonStyle?: any;
	buttonVariant?: 'text' | 'contained' | 'outlined';
	isDefaultButton?: boolean;
	handleClick?: any;
	children?: any;
	buttons?: any;
}
export const PopupComponent = ({
	open,
	title,
	subtitle,
	buttonText,
	handleClick,
	children,
	buttonStyle,
	buttonVariant,
	isDefaultButton = true,
}: IProps) => {
	return (
		<Dialog
			style={{ direction: 'rtl' }}
			onClose={undefined}
			open={open}
			sx={{
				'& .MuiPaper-root': {
					padding: '69px 47px 47px 32px',
					borderRadius: '15px!important',
					textAlign: 'center',
					display: 'flex',
					alignItems: !isDefaultButton ? 'center' : 'normal',
				},
			}}
		>
			<Typography variant="boldExtraLarge" sx={{ marginBottom: '20px' }}>
				{title}
			</Typography>
			{subtitle && (
				<Typography variant="h4" sx={{ color: 'black', marginBottom: children.length ? '0px' : '84px' }}>
					{subtitle}
				</Typography>
			)}

			{children || <></>}

			{isDefaultButton && (
				<ButtonComponent
					variantType={buttonVariant || 'contained'}
					disabled={false}
					handleClick={handleClick}
					text={buttonText}
					styleObj={buttonStyle || { borderRadius: '8px', width: '320px', height: '48px' }}
				/>
			)}
		</Dialog>
	);
};
